// src/types/group.ts

/**
 * Base group interface from API
 */
export interface Group {
  id: number;
  external_id: string;
  name: string;
  description: string;
  owner_id: number;
  owner_type: string;
  is_personal: boolean;
  created_at: string;
  updated_at: string;
  member_count?: number;     // Optional member count
  members?: GroupMember[];    // Optional, may be included when fetching group details
}

/**
 * API response for a list of groups
 */
export interface GroupListResponse {
  groups: Group[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

/**
 * Represents a member of a group (matches the current API payload)
 */
export interface GroupMember {
  user_id: number;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  role: 'admin' | 'member';
  joined_at: string;
}

/** Convenience: full display name with fallbacks */
export function memberDisplayName(m: GroupMember): string {
  const full = `${m.first_name} ${m.last_name}`.trim()
  return full || m.username || m.email
}

/**
 * Data for creating a new group
 */
export interface CreateGroupData {
  name: string;
  description?: string;
  is_personal?: boolean;
}

/**
 * Data for updating an existing group
 */
export interface UpdateGroupData {
  name?: string;
  description?: string;
}

/**
 * Data for adding a new member to a group
 */
export interface AddMemberData {
  user_id: number;
  role: 'admin' | 'member';
}

